"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManualEntryTests = void 0;
var utils_1 = require("../../support/utils");
var _0_manual_entry_1 = require("./0_manual-entry");
var _1_manual_entry_1 = require("./1_manual-entry");
var _2_5_manual_entry_1 = require("./2-5_manual-entry");
var _6_9_increments_1 = require("./6-9_increments");
var other_manual_entry_tests_1 = require("./other-manual-entry-tests");
var ManualEntryTests = /** @class */ (function (_super) {
    __extends(ManualEntryTests, _super);
    function ManualEntryTests(utils) {
        var _this = _super.call(this, utils) || this;
        _this._0 = function () { return (0, _0_manual_entry_1.manualEntry_0)(utils); };
        _this._1 = function () { return (0, _1_manual_entry_1.manualEntry_1)(utils); };
        _this._2_5 = function () { return (0, _2_5_manual_entry_1.manualEntry_2_5)(utils); };
        _this._6_9 = function () { return (0, _6_9_increments_1.manualEntry_6_9)(utils); };
        _this.other = function () { return (0, other_manual_entry_tests_1.manualEntry_other)(utils); };
        return _this;
    }
    return ManualEntryTests;
}(utils_1.TestSuite));
exports.ManualEntryTests = ManualEntryTests;
